export interface ConfigApi {
    date: string,
    status: string,
    domain: string,
    name: string,
    header: string,
    description: string,
    logo: string,
    type: string,
    layout: ConfigLayoutApi,
    coordinates: StoreConfigCoordinatesApi,
    ordering: StoreConfigOrderingApi,
    firewall: StoreConfigFirewallApi,
    analytics: StoreConfigAnalyticsApi,
    loyalty?: StoreConfigLoyaltyApi,
    company: StoreConfigCompanyApi,
    contact: StoreConfigContactApi,
    table: StoreConfigTableApi,
    languages: string[],
    tags: string[],
    address: ConfigAddressApi,
    hours: ConfigHoursApi[],
    homepage_full: boolean,
    old_settings: Record<string, string>,
    old_store: ConfigOldStoreApi;
}

export interface ConfigOldStoreApi {
    order_custom_fields: any[]
}

export interface StoreConfigTableApi {
    payment: boolean,
    call_waiter: boolean,
}

export interface ConfigLayoutApi {
    css_content: string,
    css_url: string,
    color: string,
    color_text: string,
    color_bg: string,
    template: string,
    image_link: any,
    ico_link: any,
    links: ConfigLayoutMenuApi[],
    components: ConfigLayoutComponentApi[],
    custom_texts: Record<string, string>;
    multistore_item_title_type?: MultistoreItemTitleType;
    cover_large?: string;
    multistore_layout?: MultistoreLayoutType;
    menu_multilevel: boolean;
}

export enum MultistoreItemTitleType {
    "ADDRESS" = "ADDRESS",
    "BOTH" = "BOTH",
}

export enum MultistoreLayoutType {
    "HOME_WITH_MAP" = "HOME_WITH_MAP",
    "BRAND_LIST" = "BRAND_LIST",
}

export interface ConfigAddressApi {
    city: string,
    street: string,
    build_nr: string,
    flat_nr: string,
    zip_code: string,
    country: any,
}

export interface ConfigHoursApi {
    day_from: string,
    hour_from: string,
    day_to: string,
    hour_to: string,
}

export interface ConfigLayoutMenuApi {
    title: string,
    type: string,
    link: string,
    position: number
}

export interface ConfigLayoutComponentApi {
    slug: string,
    title: string,
    placement: string,
    content: string
}

export interface StoreConfigCoordinatesApi {
    latitude: number,
    longitude: number
}

export interface StoreConfigOrderingApi {
    enabled: boolean;
    mode: "ENABLED" | "ORDER_AND_SCAN" | "READ_ONLY";
    countries: string[];
    search_type: string,
    default_order_type: string;
    delivery: boolean;
    takeaway: boolean;
    dine_in: boolean;
    room_service: boolean;
    estimated_preparation_duration: number;
    estimated_delivery_duration: number;
    cancellation_time: number;
    customer_success_info: string;
    customer_reject_info: string;
    min_order_price_money: number;
    delivery_price_money: number;
    cities_radius: string;
    table: boolean;
    dine_in_pick_up: boolean;
    scanner_disabled: boolean;
    number_editable: boolean;
    tip: boolean;
    rules: StoreConfigRulesApi[];
    payment_methods: StoreConfigPaymentMethodApi[];
    dine_in_counter: boolean;
    dine_in_table: boolean;
    item_comment: boolean;
    order_scheduling_mode: OrderSchedulingMode;
}

export type StoreConfigPaymentMethodApi = {
    id?: string;
    name?: string;
    description?: string
    gateway?: string
    order_types?: string[]
    payment_types?: string[]
};

export type StoreConfigFirewallApi = {
    password?: string;
    enabled?: boolean
};
export type StoreConfigAnalyticsApi = {
    google_analytics_id?: string;
    facebook_pixel_id?: string
};

export interface StoreConfigLoyaltyApi {
    enabled: boolean,
    rules: StoreConfigRulesApi[],
    qrcode?: boolean,
    registration?: StoreConfigLoyaltyRegistrationApi,
    points?: StoreConfigLoyaltyProgramApi,
    vouchers?: StoreConfigLoyaltyProgramApi,
    groups?: StoreConfigLoyaltyProgramApi,
    cashback?: StoreConfigLoyaltyProgramApi,
    custom_fields: StoreConfigLoyaltyCustomFieldApi[]
}

export interface StoreConfigLoyaltyProgramApi {
    enabled: boolean,
    info: string
}

export interface StoreConfigLoyaltyRegistrationApi {
    enabled: boolean,
    banner_text: string
}

export interface StoreConfigLoyaltyCustomFieldApi {
    slug: string,
    type: string,
    name: string,
    options?: string[],
    required: boolean
}

export interface StoreConfigCompanyApi {
    address: ConfigAddressApi,
    legal_name: string,
    tax_id_no: string
}

export interface StoreConfigContactApi {
    email: string,
    phone: string
}

export interface StoreConfigRulesApi {
    slug: string,
    type: string,
    content?: string,
    link?: string,
    order_types: string[]
}

// LOCATIONS

export interface LocationCheckApi {
    country: string,
    city: string,
    street: string,
    build_nr: string,
    estimated_delivery_duration: number,
    estimated_preparation_duration: number,
    min_order_price_money: any,
    delivery_price_money: any,
    free_delivery_price_money: any,
    in_delivery_area: boolean,
    coordinates: StoreConfigCoordinatesApi
}

//USER


export interface LoginApi {
    token: string;
    contact: ContactApi
}

export interface ContactApi {
    id: number;
    name: string;
    email: string;
    phone_number: string;
    points: number;
    verified: boolean;
    available_promotional_credit_price: MoneyApi;
    group_id: string;
    group_name: string;
    reference_id?: string;
    temp_card_code?: string;
    temp_card_expiry_date?: string;
}

export interface UpdateContactApi {
    name?: string;
    phone_number?: string
}


export interface VoucherApi {
    id: number;
    name: string;
    product_id: string;
    code: string;
    credit: any;
    expiration_at: any;
    status: string;
    promotion_id: string;
    supported_online: boolean;
}

//Page
export interface PageApi {
    title: string;
    slug: string;
    content: string;
    settings: any
}


//Multistore
export interface PlaceApi {
    name: string;
    header?: string;
    store_url: string;
    domain: string;
    phone_number: string;
    types: OrderType[],
    in_delivery_zone: boolean,
    address: any,
    delivery?: any,
    coordinates: any,
    distance?: number
    cover_large?: string;
    cover_small?: string;
    logo_small?: string;
    status: PlaceStatus;
    hours?: ConfigHoursApi[];
    icon_small?: string;
}

export type PlaceStatus = "ACTIVE" | "PAUSED" | "DISABLED" | "DELETED";

export interface PlaceDeliveryApi {
    delivery_price: string,
    min_order_price: string
}

//ERRORS

export type Exception = Error & {
    errors?: ApiError[];
    status?: number;
    url?: string;
    data?: any;
};

export interface ApiError {
    code?: string;
    field?: string;
    message: string;
    type?: string;
    value?: string;
    missing_permissions?: string[];
    eligible_users?: string[];
    arguments?: Record<string, string | number | undefined>;
    organization_name?: string;
}

//GENERIC

export interface ListResponse<T> {
    data: Array<T>;
}

export interface ItemResponse<T> {
    data: T;
}

export interface MoneyApi {
    amount: number;
    currency: string;
}

//Store

export interface CityApi {
    city_name: string;
    country_code: string;
    full_slug: string;
    postal_code: string;
    reference_id: string;
}

export interface StreetApi {
    name: string;
    postal_code: string;
    district: string;
    full_name: string;
}

export enum OrderType {
    "DINE_IN" = "DINE_IN",
    "PICK_UP" = "PICK_UP",
    "DELIVERY" = "DELIVERY",
    "ROOM_SERVICE" = "ROOM_SERVICE",
}

export enum DineInType {
    "TABLE" = "TABLE",
    "COUNTER" = "COUNTER",
}

export enum CategoryViewType {
    "BASIC" = "BASIC",
    "IMAGE" = "IMAGE",
}

export enum MenuProductViewType {
    "HORIZONTAL" = "HORIZONTAL",
    "VERTICAL_SMALL_IMAGE" = "VERTICAL_SMALL_IMAGE",
    "VERTICAL_BIG_IMAGE" = "VERTICAL_BIG_IMAGE",
}

export type GroupedHours = Record<string, ConfigHoursApi[]>;

export type AvailabilityInfo = {
    text: string;
    typesText?: string;
    dateText?: string;
    currentType?: boolean;
    isNowAvailable?: boolean;
    includeCurrentType?: boolean;
    isEverAvailable?: boolean;
}

export enum OrderSchedulingMode {
    "DISABLED" = "DISABLED",
    "ENABLED" = "ENABLED",
    "SAME_DAY" = "SAME_DAY",
}

export interface UpsellApi {
    id: number;
    name: string;
    priority: number;
    status: "ENABLED" | "DELETED" | "DISABLED";
    visibility_type: UpsellVisibilityType;
    entities: UpsellEntityApi[];
    expressions: UpsellExpressionApi[];
}

export interface UpsellEntityApi {
    id: number;
    position: number;
    entity_id: string;
    type: UpsellEntityType;
}

export interface UpsellExpressionApi {
    id: number;
    operator: "AND";
    conditions: UpsellConditionApi[];
}

export interface UpsellConditionApi {
    id: number;
    operator: UpsellConditionOperator;
    type: UpsellConditionType;
    value: string;
    category_id?: number;
    item_id?: number;
}

export enum UpsellVisibilityType {
    ALL = "ALL",
    MISSING = "MISSING",
    NONE_IF_ANY_INCLUDED = "NONE_IF_ANY_INCLUDED",
}

export enum UpsellConditionType {
    "ORDER_TOTAL_PRICE" = "ORDER_TOTAL_PRICE",
    "ORDER_ITEM_COUNT" = "ORDER_ITEM_COUNT",
    "ORDER_TYPE" = "ORDER_TYPE",
    "AVAILABILITY" = "AVAILABILITY",
    "ORDER_SOURCE" = "ORDER_SOURCE"
}

export enum UpsellConditionOperator {
    "GREATER_THAN" = "GREATER_THAN",
    "LESS_THAN" = "LESS_THAN",
    "NOT_EQUALS" = "NOT_EQUALS",
    "EQUALS" = "EQUALS",
    "LESS_THAN_OR_EQUAL_TO" = "LESS_THAN_OR_EQUAL_TO",
    "GREATER_THAN_OR_EQUAL_TO" = "GREATER_THAN_OR_EQUAL_TO",
}

export type UpsellEntityType = "ITEM" | "ITEM_GROUP";

export type PromotionEntityType = "ITEM" | "CATEGORY";

export type ParsedCategory = {
    id: any;
    position: number;
    name: string;
    image_link: any;
    description: string;
    entities: any[];
    menuIds: number[];
    originalIds: number[];
};

export interface PromotionApi {
    id: number;
    room_service: boolean;
    delivery: boolean;
    dine_in: boolean;
    takeaway: boolean;
    conditions: Record<string, any>[];
    min_condition_quantity?: number;
    min_basket_money?: MoneyApi;
    entities: PromotionEntityApi[];
    expressions: PromotionExpressionApi[];
    availability_id?: number;
    usage_limit?: number;
    new_version: boolean;
    description?: string;
    limit_per_order?: number;
    add_type: "MANUALLY" | "AUTO";
}

export interface PromotionEntityApi {
    id: number;
    type: PromotionEntityType;
    entity_id: number;
    volume: number;
    promotion_type: PromotionEntityPromotionType;
}

export enum PromotionEntityPromotionType {
    "FIXED_PRICE" = "FIXED_PRICE",
    "AMOUNT" = "AMOUNT",
    "PERCENT" = "PERCENT",
}

export interface PromotionExpressionApi {
    conditions: PromotionExpressionConditionApi[];
    operator: "AND";
}

export interface PromotionExpressionConditionApi {
    operator: PromotionConditionOperator;
    type: PromotionConditionType;
    value: string | number;
    category_id?: number;
    item_id?: number;
    item_group_id?: number;
}

export enum PromotionConditionOperator {
    "GREATER_THAN" = "GREATER_THAN",
    "LESS_THAN" = "LESS_THAN",
    "NOT_EQUALS" = "NOT_EQUALS",
    "EQUALS" = "EQUALS",
    "LESS_THAN_OR_EQUAL_TO" = "LESS_THAN_OR_EQUAL_TO",
    "GREATER_THAN_OR_EQUAL_TO" = "GREATER_THAN_OR_EQUAL_TO",
    "EXISTS" = "EXISTS",
    "NOT_EXISTS" = "NOT_EXISTS",
}

export enum PromotionConditionType {
    "ORDER_TOTAL_PRICE" = "ORDER_TOTAL_PRICE",
    "ORDER_TOTAL_PRICE_NET" = "ORDER_TOTAL_PRICE_NET",
    "ORDER_ITEM_COUNT" = "ORDER_ITEM_COUNT",
    "ORDER_TYPE" = "ORDER_TYPE",
    "ORDER_SOURCE" = "ORDER_SOURCE",
    "GUEST_COUNT" = "GUEST_COUNT",
    "CLIENT_GROUP" = "CLIENT_GROUP"
}

export enum OrderTrackingStatus {
    "NEW" = "NEW",
    "PREPARATION" = "PREPARATION",
    "READY" = "READY",
    "DELIVERY" = "DELIVERY",
    "RECEIVED" = "RECEIVED",
}

export interface OrderApi {
    id: number;
    token: string;
    type: OrderType;
    accept_marketing: boolean;
    tracking_status?: OrderTrackingStatus;
    status: OrderStatus;
    payment_status: OrderPaymentStatus;
    contact?: ContactApi;
    address?: ConfigAddressApi;
    comment?: string;
    number?: number;
    pickup_at?: string;
    confirmed_at?: string;
    estimated_preparation_at?: string;
    reason?: string;
    items: OrderItemApi[];
    promotions: Record<string, any>[];
    tracking: {
        accepted_at?: string;
        estimated_preparation_at?: string;
        preparation_at?: string;
        received_at?: string;
    };
    coordinates?: StoreConfigCoordinatesApi;
    pickup_number?: string;
}

export enum OrderStatus {
    "CANCELED" = "CANCELED",
    "REJECTED" = "REJECTED",
    "ACCEPTED" = "ACCEPTED",
    "WAITING_FOR_ACCEPTED" = "WAITING_FOR_ACCEPTED",
    "CONFIRMED" = "CONFIRMED",
    "OPEN" = "OPEN",
    "CLOSED" = "CLOSED",
}

export enum OrderPaymentStatus {
    "FAILURE" = "FAILURE",
    "PROGRESS" = "PROGRESS",
    "OPEN" = "OPEN",
}

export interface OrderItemApi {
    id: number;
    item_id: number;
    base_total_money: MoneyApi;
    base_unit_price_money: MoneyApi;
    created_at: string;
    name: string;
    quantity: number;
    unit_price_money: MoneyApi;
    total_money: MoneyApi;
    modifier_groups: {
        id: number;
        modifier_group_id: number[];
        name: string;
        selected_items: Record<string, any>[];
    };
    discount_money?: MoneyApi;
    comment?: string;
}